// Statistics Actions
export const FETCH_STATISTICS_REQUEST = 'FETCH_STATISTICS_REQUEST';
export const FETCH_STATISTICS_SUCCESS = 'FETCH_STATISTICS_SUCCESS';
export const FETCH_STATISTICS_FAILURE = 'FETCH_STATISTICS_FAILURE';

// Action Creators
export const fetchStatisticsRequest = (params = {}) => ({
    type: FETCH_STATISTICS_REQUEST,
    payload: params,
});

export const fetchStatisticsSuccess = (data) => ({
    type: FETCH_STATISTICS_SUCCESS,
    payload: data,
});

export const fetchStatisticsFailure = (error) => ({
    type: FETCH_STATISTICS_FAILURE,
    payload: error,
});



